export const COLLECTION_SCHEMAS = {
  services: {
    title: "Services",
    desc: "These cards power the homepage bento grid and the /services menu.",
    titleKey: "title",
    imgKey: "image_url",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "slug", label: "Slug (URL path)", type: "text", hint: "e.g. website-development → /services/website-development" },
      { key: "tagline", label: "Tagline", type: "textarea", rows: 2 },
      { key: "icon", label: "Icon (Lucide name)", type: "text", hint: "Globe, Target, Magnet, Clapperboard, Rocket..." },
      { key: "price", label: "Price", type: "text", hint: "e.g. ₹14,999 or ₹7,999/mo" },
      { key: "strike_price", label: "Strike Price", type: "text" },
      { key: "badge", label: "Offer Badge", type: "text", hint: "e.g. Most Popular — leave empty to hide" },
      { key: "image_url", label: "Card Image", type: "image" },
    ],
  },
  samples: {
    title: "Website Samples",
    desc: "Shown on /samples and inside the Website Development service gallery.",
    titleKey: "title",
    imgKey: "image_url",
    fields: [
      { key: "title", label: "Project Title", type: "text" },
      { key: "category", label: "Category", type: "text", hint: "Used as filter — e.g. Real Estate, Fitness" },
      { key: "price", label: "Price", type: "text" },
      { key: "badge", label: "Badge", type: "text" },
      { key: "image_url", label: "Screenshot / Mockup", type: "image" },
      { key: "preview_url", label: "Live Preview URL (optional)", type: "text" },
    ],
  },
  ugc_models: {
    title: "UGC Models",
    desc: "Creator library shown on the UGC Videos service page.",
    titleKey: "name",
    imgKey: "photo_url",
    fields: [
      { key: "name", label: "Creator Name", type: "text" },
      { key: "language", label: "Language(s)", type: "text" },
      { key: "price", label: "Price per video", type: "text" },
      { key: "availability", label: "Availability", type: "select", options: ["Available", "Booked"] },
      { key: "photo_url", label: "Photo", type: "image" },
      { key: "video_url", label: "Reel / Video Link", type: "text" },
    ],
  },
  proofs: {
    title: "Proofs Gallery",
    desc: "Dashboards & results. Tag with a service slug to also show it on that service page.",
    titleKey: "title",
    imgKey: "image_url",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "metric", label: "Metric Highlight", type: "text", hint: "e.g. 4.2x ROAS" },
      { key: "service_slug", label: "Service Slug (optional)", type: "text", hint: "ad-setup, lead-generation, website-development, ugc-videos" },
      { key: "image_url", label: "Screenshot", type: "image" },
    ],
  },
  testimonials: {
    title: "Testimonials",
    desc: "Client reviews shown in the masonry grid and /testimonials page.",
    titleKey: "name",
    imgKey: "avatar_url",
    fields: [
      { key: "name", label: "Client Name", type: "text" },
      { key: "role", label: "Role", type: "text" },
      { key: "company", label: "Company", type: "text" },
      { key: "rating", label: "Rating (1-5)", type: "number" },
      { key: "text", label: "Review Text", type: "textarea", rows: 4 },
      { key: "avatar_url", label: "Avatar", type: "image" },
    ],
  },
  faqs: {
    title: "FAQs",
    desc: "Shown on the homepage section and the /faq page.",
    titleKey: "question",
    fields: [
      { key: "question", label: "Question", type: "text" },
      { key: "answer", label: "Answer", type: "textarea", rows: 4 },
      { key: "category", label: "Category", type: "text", hint: "Pricing, Process, Ads, UGC, Support" },
    ],
  },
};
